import React from 'react';
import './ForgotPassword.scss';
import Grid from "@mui/material/Grid";

const ForgotPassword = () => {

    const passwordUrl = 'http://www.greateratlantic.fisheries.noaa.gov/apps/login/forgot';

    return (
        <div>
        <h3 className="sectionTitle center">Forgot Password</h3>
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} lg={6} style={{ wordBreak: "break-word"}}>
           Password retrieval is currently available if you have previously registered an email address with NMFS. You can retrieve your password via the web here:
            <a href={passwordUrl}  target={"_blank"} rel="noopener noreferrer"> {passwordUrl}</a>
        </Grid>
        <Grid item xs={12}>
        </Grid>
        </Grid>
        <Grid item xs={12} lg={6}>
            For assistance, please call <a href="tel:978-281-9188">(978) 281-9188</a>.
        </Grid>
        </div>
    );
}

export default ForgotPassword;
